var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileHexagonGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.4185 9.22306L33.4192 9.22346C34.0924 9.60501 34.5 10.3065 34.5 11.0637V27.9363C34.5 28.6935 34.0924 29.395 33.4192 29.7765L33.4185 29.7769L18.5871 38.2133L18.5861 38.2138C17.9195 38.595 17.0884 38.5961 16.4122 38.2129L1.58152 29.7769L1.58083 29.7765C0.907555 29.395 0.5 28.6935 0.5 27.9363V11.0637C0.5 10.3065 0.907554 9.60501 1.58083 9.22346L1.58152 9.22306L16.4129 0.786727L16.4139 0.786174C17.0805 0.405035 17.9114 0.403906 18.5876 0.787005C18.5877 0.787043 18.5877 0.787081 18.5878 0.787119L33.4185 9.22306Z",
    fill: "#30CFB0",
    stroke: "#30CFB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHexagonGreen);
export default __webpack_public_path__ + "static/media/mobile_hexagon_green.80e4afd16a74f7afa572790fb90a0f87.svg";
export { ForwardRef as ReactComponent };